import { axiosRequest } from "../../configs/axios.config";

export class EnterpriseAreaService {
  getAllWithParams(tenantId, success, error) {
    const url = !!!tenantId
      ? `/enterprise_areas`
      : `/tenants/${tenantId}/enterprise_areas`;

    axiosRequest
      .get(url)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }

  getAll(success, error) {
    axiosRequest
      .get("/enterprise_areas")
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }
}
